import { SEALED_VINYL_DELIVERY_FEE_KRW, SEALED_VINYL_UNIT_PRICE_KRW } from './constants'

/** 원화 금액을 콤마 포맷한다. (예: 4500 → "4,500") */
export function formatPriceKrw(value: number): string {
  return value.toLocaleString('ko-KR')
}

export interface SealedVinylAmounts {
  itemAmount: number
  deliveryFee: number
  totalAmount: number
}

/**
 * 밀봉비닐 금액 계산 — 상품가(수량×단가) + 배송비.
 * 현재 단가 0원(무료 나눔)이라 총액은 사실상 배송비 고정이지만,
 * 단가가 생길 경우 대비해 수량 곱으로 일반화한다. (OrderStep·PaymentStep 공용)
 */
export function calcSealedVinylAmounts(quantity: number): SealedVinylAmounts {
  const itemAmount = quantity * SEALED_VINYL_UNIT_PRICE_KRW
  const deliveryFee = SEALED_VINYL_DELIVERY_FEE_KRW
  return { itemAmount, deliveryFee, totalAmount: itemAmount + deliveryFee }
}

/** 수량 변경 마감 시각 — 정책상 '신청일 기준 익일 오전 11시'. */
const EDIT_DEADLINE_HOUR = 11

/**
 * Java LocalDateTime 배열 [y, M, d, h, m, s] → Date.
 * 백엔드 product-orders/detail 의 registeredAt 직렬화 형태.
 */
export function registeredAtArrayToDate(arr: number[]): Date {
  const [y = 0, m = 1, d = 1, h = 0, min = 0, s = 0] = arr
  return new Date(y, m - 1, d, h, min, s)
}

/** 배열 registeredAt → 헤딩 포맷 ("YYYY년 M월 D일(요일) 신청") */
export function formatRegisteredAtForHeading(arr: number[]): string {
  const date = registeredAtArrayToDate(arr)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const dayOfWeek = ['일', '월', '화', '수', '목', '금', '토'][date.getDay()]
  return `${year}년 ${month}월 ${day}일(${dayOfWeek}) 신청`
}

/**
 * 수량 변경·신청 취소 가능 기한 — 신청일(registeredAt) 기준 익일 오전 11:00.
 * 이 시각이 지나면 변경/취소할 수 없다. (useEditWindowExpiry·OrderDetailView 공용)
 */
export function getEditDeadline(arr: number[]): Date {
  const created = registeredAtArrayToDate(arr)
  return new Date(created.getFullYear(), created.getMonth(), created.getDate() + 1, EDIT_DEADLINE_HOUR, 0, 0, 0)
}

/** 배열 registeredAt 기준 수량 변경 가능 기한 만료 여부. */
export function isRegisteredAtChangeExpired(arr: number[]): boolean {
  return Date.now() >= getEditDeadline(arr).getTime()
}
